import axios from 'axios'
import router from '../router'                       // 路由配置文件
import { Message } from 'element-ui'

const ENV = process.env.NODE_ENV
const BASE_API = process.env.BASE_API     //  连接测试服务器 请求跨域数据
//const WS_API = process.env.WS_API         //  连接测试服务器 websroket
// const BASE_API = 'http://175.6.4.138:3678/cscloud'   // 杨赛君
 const WS_API = 'ws://47.104.85.9:8088'   // 余秋月
// const BASE_API = 'http://localhost:8888'
// const BASE_API = 'http://ai.catmore.cc:8888'   // 赵芝英

// 创建axios实例
const service = axios.create({
  baseURL: BASE_API,
  timeout: 60000
})

// request 请求发送之前 拦截器
service.interceptors.request.use(config => {
  const Authorization = sessionStorage.getItem('Authorization')
  if (Authorization) {
    config.headers['Authorization'] = Authorization // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// request 请求收到后 拦截器设置
service.interceptors.response.use(
  response => {
    if (response) {
      switch (response.data.code) {
        case 'H0000':
          break
        case 'B1000':                                 //  清除token信息并跳转到登录页面
          sessionStorage.removeItem('Authorization')  // 将token清空
          Message.error(response.data.data.msg)       // 提示错误信息
          router.replace({ path: '/login' })
          break
        default:
       //   Message.error(response.data.data.msg ? response.data.data.msg : '返回状态非H0000')
           // Message.error('系统维护中，请稍后刷新重试！')
            Message.error(response.data.data.msg)
      }
      return response.data
    } else {
      Message.error('响应成功，但是响应信息不存在！')
     //   Message.error('系统维护中，请稍后刷新重试！')
    }
  },
  error => {
   // Message.error(ENV === 'development' ? error.message : '请求错误！')


     if( error.response.status==404)
     {
         Message.error('系统维护中，请稍后刷新重试！')
     }else if(error.response.status==500)
     {
         Message.error(error.response.data.message)
     }else {
         Message.error('网络异常！')
     }
    return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  })
export { BASE_API, WS_API }
export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js